module.exports = __webpack_public_path__ + "media/images/btn-arrow-dark-ec294e554b1e25e1d420ed714d4cf347.svg";